import { createStore } from 'vuex';

import user from './modules/user';
import book from './modules/book';
import bookmark from './modules/bookmark.js';
import message from './modules/message.js';
import weight from './modules/weight.js';

export const store = createStore({
    modules: {
        user,
        book,
        bookmark,
        message,
        weight
    },
});
